module.exports = __webpack_public_path__ + "static/media/etc-bd.6b6a81e0.jpg";